import { useState, useRef } from "react";
import { Tooltip, IconButton } from "@mui/material";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import DishSequenceMenu from "./DishSequenceMenu";
type PropsDishSequenceTrigger = {
  rows: any[];
  fetchDishes: () => Promise<void>;
};

const DishSequenceTrigger:React.FC<PropsDishSequenceTrigger> = ({ rows, fetchDishes }) => {
  const [openSequenceMenu, setOpenSequenceMenu] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <Tooltip title="Normalize Sequence" arrow placement="bottom">
        <IconButton
          ref={anchorRef}
          size="small"
          color="primary"
          disabled={rows.length === 0}
          onClick={() => setOpenSequenceMenu(true)}
        >
          <CachedOutlinedIcon
            sx={{
              fontSize: "1rem",
              opacity: openSequenceMenu ? 0.5 : 1,
              transition: "all 0.3s ease-in-out",
              transform: openSequenceMenu ? "rotate(360deg)" : "rotate(0deg)",
            }}
          />
        </IconButton>
      </Tooltip>

      <DishSequenceMenu
        open={openSequenceMenu}
        anchorEl={anchorRef.current}
        onClose={() => setOpenSequenceMenu(false)}
        fetchDishes={fetchDishes}
        setOpenSequenceMenu={setOpenSequenceMenu}
        rows={rows}
      />
    </>
  );
};

export default DishSequenceTrigger;
